const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const LOCAL_DRAFT_STORAGE_PREFIX = "gamification:create-draft";
export const LOCAL_DRAFT_VERSION = 2;
export const LOCAL_DRAFT_TTL_DAYS = 7;
export const LOCAL_DRAFT_TTL_MS = LOCAL_DRAFT_TTL_DAYS * MS_PER_DAY;
export const LOCAL_DRAFT_SAVE_DEBOUNCE_MS = 800;
